import { useState } from "react";
import './onboard.css';
import { useAuth } from "../../../utils/authContext";
import { useNavigate } from 'react-router-dom';
import { useAlert } from "../../../hooks/useAlert";
import axios from 'axios';
import ObWelcome from "./obWelcome";
import ObPlace from "./obPlace";
import ObContact from "./obContact";
import ObBank from "./obBank";
import ObTax from "./obTax";
import ObPartner from "./obPartner";

const API_URL = process.env.REACT_APP_API_URL;

function OnboardForm() {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({});
    const { user } = useAuth() || {};
    const navigate = useNavigate();
    const { showAlert } = useAlert();

    const handleNextStep = (data) => {
        setFormData((prevData) => ({ ...prevData, ...data }));
        setStep(step + 1);
    };

    const handlePreviousStep = () => {
        setStep(step - 1);
    };

    const handleUpdateData = (data) => {
        setFormData((prevData) => ({ ...prevData, ...data }));
    };

    const handleLastStep = async (data) => {
        const confirmSubmit = window.confirm(
            'Möchtest du alles so abschicken? Du kannst es auch später in den Einstellungen ändern/ ergänzen.'
        );
        if (!confirmSubmit) return;
        try {
            await axios({
                method: 'PATCH',
                url: `${API_URL}/users/updateMe`,
                withCredentials: true,
                data: {
                    ...formData,
                    ...data,
                    onboardCompleted: true,
                }
            })
            showAlert('Daten erfolgreich gespeichert!', 'success');
            setTimeout(() => navigate('/dashboard'), 1000);
        } catch (error) {
            showAlert('Fehler beim Speichern der Daten. Bitte versuche es erneut.', 'error');
        }
    };

    return (
        <div className='onboardContainer'>
            {step === 1 && <ObWelcome userName={user?.prename ?? 'Nutzer'} onNext={handleNextStep} formData={formData} />}
            {step === 2 && (
                <ObPartner 
                    onNext={handleNextStep}
                    onBack={handlePreviousStep}
                    formData={formData}
                    onUpdateData={handleUpdateData}
                />
            )}
            {step === 3 && (
                <ObPlace
                    onNext={handleNextStep}
                    onBack={handlePreviousStep}
                    formData={formData}
                    onUpdateData={handleUpdateData}
                />
            )}
            {step === 4 && (
                <ObContact
                    onNext={handleNextStep}
                    onBack={handlePreviousStep}
                    formData={formData}
                    onUpdateData={handleUpdateData}
                />
            )}
            {step === 5 && (
                <ObBank
                    onNext={handleNextStep}
                    onBack={handlePreviousStep}
                    formData={formData}
                    onUpdateData={handleUpdateData}
                />
            )}
            {step === 6 && (
                <ObTax
                    onNext={handleLastStep}
                    onBack={handlePreviousStep}
                    formData={formData}
                    onUpdateData={handleUpdateData}
                />
            )}
        </div>
    );
}

export default OnboardForm;